import { twdClass } from "../../../constants/tailwind.constants";
import { INPUT_TEXT, BTN_CLS } from "../../../constants/var.constants";
import PagesGoogleParams from "../pages/PagesGoogleParams";
import { set, cloneDeep, find, merge } from "lodash";
import { toast } from "react-toastify";
import {Button} from "../../ui/com_ui";
import { 
  RIGHT_PANEL_TOGGEL,
  UPDATE_PROJECT_INFO,
  UPDATE_PROJECT_PAGE,
  UPDATE_PAGE_CONFIG,
} from "../../../constants/action.constants";

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector} from "react-redux";


const PageDataHeaderBtn = ({}) => {
  const dispatch = useDispatch();
  const {
    pageInfo,
    pageConfig,
    projectData: { connections, project_id },
  } = useSelector((state) => state.studioDetails);
  
  const {blocks=[], settings={}} = pageInfo
  const {pageType=''} = settings
  const {active=false, original=[]} = pageConfig
  if(!original.length) return <>1</>
  
  const updatePageProps = (pageProps =[]) => {
    let data = cloneDeep(pageInfo)
    pageProps.map((prop)=>{
      data = set(data, prop[0], prop[1]);
    })
    //console.log("update", data)
    dispatch({ type: UPDATE_PROJECT_PAGE, data });
  };

  const closeDynamicPreview = () => {
    dispatch({
      type: UPDATE_PAGE_CONFIG,
      data: {
        ...pageConfig,
        original:false
      },
    });
    updatePageProps([ 
      ["blocks", original]
    ])
  }
  return (
    <Button  onClick={closeDynamicPreview}
      type={'default'} 
      cType={'iconText'}             
      color={'primary'}  
      size={"lg"}       
      iconImg={'x-02.svg'}          
      className={'mr-2'}          
    >Close Dynamic Page Preview</Button>
  );
};

export default PageDataHeaderBtn;